module.exports = __webpack_public_path__ + "assets/img/calc.61b878a2.svg";